import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import Layout from "../../components/Layout";
import { fetchData } from "../../utils/apiUtils";
import { useLang } from "../../utils/LangContext";
import localStorageHelper from "../../utils/localStorageHelper";

function PrivateCreateTeam() {
  const { t } = useLang();
  const navigate = useNavigate();

  // pull stored game once
  const storedGame = localStorageHelper.getItem("game");

  const [form, setForm] = useState({
    team_name: "",
    game_code: storedGame?.hash || "",
    email: "",
  });
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState(null);

  // for showing existing team if any
  const [localData] = useState(localStorageHelper.getItem("team"));

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.team_name.trim())
      newErrors.team_name = t("Team Name is required");
    if (!form.game_code.trim())
      newErrors.game_code = t("Game Code is required");
    if (!form.email.trim()) {
      newErrors.email = t("Email is required");
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(form.email)
    ) {
      newErrors.email = t("Enter a valid email address");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const url = `/api/v1/game/create-team/?game_hash=${encodeURIComponent(
      form.game_code
    )}&team_name=${encodeURIComponent(
      form.team_name
    )}&email=${encodeURIComponent(form.email)}`;

    try {
      const response = await fetchData(url);

      if (response.answerOK) {
        localStorageHelper.setItem("team", response);

        navigate("/game", {
          state: {
            game_id: response.game_id,
            team_name: response.team_name,
            team_code: response.team_code,
            is_admin: response.is_admin,
          },
        });
      } else {
        setAlert(response.error || t("Unknown error"));
      }
    } catch (err) {
      setAlert(t("Error creating the team") + ": " + err.message);
    }
  };

  return (
    <Layout>
      <div className="text-center">
        {localData?.team_code && (
          <div className="text-success mb-4">
            {t("You already have ongoing game")}:{" "}
            <strong>{localData.team_code}</strong>{" "}
            <Link to="/game" className="btn btn-secondary btn-sm ms-2">
              {t("Continue playing")}
            </Link>
          </div>
        )}

        <h1 className="fw-bold mb-4">{t("Create New Team")}</h1>

        {alert && <Alert variant="danger">{alert}</Alert>}

        <form onSubmit={onSubmitHandler}>
          <div className="mb-3">
            <input
              type="text"
              name="team_name"
              className="form-control"
              placeholder={t("Team Name")}
              value={form.team_name}
              onChange={handleChange}
            />
            {errors.team_name && (
              <div className="text-danger">{errors.team_name}</div>
            )}
          </div>

          <div className="mb-3">
            <input
              type="text"
              name="game_code"
              className="form-control"
              placeholder={t("Game Code")}
              value={form.game_code}
              disabled={!!form.game_code}
              onChange={handleChange}
            />
            {errors.game_code && (
              <div className="text-danger">{errors.game_code}</div>
            )}
          </div>

          <div className="mb-3">
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder={t("Email")}
              value={form.email}
              onChange={handleChange}
            />
            {errors.email && <div className="text-danger">{errors.email}</div>}
          </div>

          <button type="submit" className="btn btn-primary w-100">
            {t("Create")}
          </button>
        </form>
      </div>
    </Layout>
  );
}

export default PrivateCreateTeam;
